import { generate, type ToVariants } from '@/components/experiments/Core/generateBasicExperimentComponent';

// ?preferred_variant=TITLE_DETAIL_LOGGED_IN_EXP:control
// ?preferred_variant=TITLE_DETAIL_LOGGED_IN_EXP:variant_1
// ?preferred_variant=TITLE_DETAIL_LOGGED_IN_EXP:variant_2

// ?remove_preferred_experiment=TITLE_DETAIL_LOGGED_IN_EXP

export const TitlePageLoggedInExpName = 'TITLE_DETAIL_LOGGED_IN_EXP' as const;

export type TitlePageLoggedInExpVariants = ToVariants<typeof TitlePageLoggedInExpVariants>;

export const TitlePageLoggedInExpVariants = {
	CONTROL: 'control',
	VARIANT_1: 'variant_1',
	VARIANT_2: 'variant_2',
} as const;

export default generate(
	TitlePageLoggedInExpName,
	TitlePageLoggedInExpVariants,
	() => {
		return true;
	},
	async instance => {
		return !!instance.$store.getters['user/isLoggedIn'];
	}
);
